import { CreatePollResponse } from "./interfaces";

export const formatVotingResponse = (
    response: CreatePollResponse
): CreatePollResponse => {
    const commentsArr = JSON.parse(JSON.stringify(response.data.comments));

    return {
        ...response,
        data: {
            ...response.data,
            comments: {
                count: commentsArr.length,
                list: [],
                isLoading: false,
                isExpanded: false,
                loadMore: false,
            },
        },
    };
};
